var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSearchFilterIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.6666 2.375L12.6666 11.875M12.6666 11.875C11.3549 11.875 10.2916 12.9383 10.2916 14.25C10.2916 15.5617 11.355 16.625 12.6666 16.625C13.9783 16.625 15.0416 15.5617 15.0416 14.25C15.0416 12.9383 13.9783 11.875 12.6666 11.875ZM6.33329 7.125L6.33329 16.625M6.33329 7.125C5.02162 7.125 3.95829 6.06168 3.95829 4.75C3.95829 3.43832 5.02162 2.375 6.33329 2.375C7.64497 2.375 8.70829 3.43832 8.70829 4.75C8.70829 6.06168 7.64497 7.125 6.33329 7.125Z",
    stroke: "#424242",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchFilterIcon);
export default __webpack_public_path__ + "static/media/search-filter_Icon.4184d68ceea2f623ab459742f7b1d701.svg";
export { ForwardRef as ReactComponent };